/* ══════════════════════════════════════════════════════
   MISE Kitchen Co. — Interactions & Motion Layer
   ══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── 1. Header — shrink + shadow on scroll ─── */
  (function initHeaderScroll() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    let lastY = 0;
    let ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const y = window.scrollY;
          if (y > 60) {
            header.classList.add('mise-header--scrolled');
          } else {
            header.classList.remove('mise-header--scrolled');
          }
          if (y > 200) {
            if (y > lastY + 4) {
              header.classList.add('mise-header--hidden');
            } else if (y < lastY - 4) {
              header.classList.remove('mise-header--hidden');
            }
          } else {
            header.classList.remove('mise-header--hidden');
          }
          lastY = y;
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ─── 2. Scroll-reveal entrance animations ─── */
  (function initScrollReveal() {
    const elements = document.querySelectorAll(
      '.card-wrapper, .title-wrapper, .multicolumn-card, ' +
      '.newsletter, .footer-block, .mise-trust-item, ' +
      '.collection-description, .product__title'
    );

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('mise-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el) => {
      if (el.classList.contains('card-wrapper')) {
        const siblings = el.parentElement
          ? el.parentElement.querySelectorAll('.card-wrapper')
          : [];
        const idx = Array.from(siblings).indexOf(el) % 4;
        el.style.transitionDelay = idx * 60 + 'ms';
      }
      el.classList.add('mise-reveal');
      observer.observe(el);
    });
  })();

  /* ─── 3. Cart count bubble — pulse on add ─── */
  (function initCartPulse() {
    function pulse() {
      const bubble = document.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('mise-cart-pulse');
      void bubble.offsetWidth;
      bubble.classList.add('mise-cart-pulse');
    }
    document.addEventListener('cart:updated', pulse);
    document.addEventListener('product-added-to-cart', pulse);
  })();

  /* ─── 4. Nav link hover underlines ─── */
  (function initNavUnderlines() {
    document
      .querySelectorAll('.header__menu-item-link, .list-menu__item--link')
      .forEach((link) => link.classList.add('mise-nav-link'));
  })();

  /* ─── 5. Asymmetric grid — every 5th card gets featured treatment ─── */
  (function initAsymmetricGrid() {
    document.querySelectorAll('.product-grid').forEach((grid) => {
      const cards = grid.querySelectorAll('.card-wrapper');
      if (cards.length < 5) return;
      cards.forEach((card, i) => {
        if (i % 5 === 0) card.classList.add('mise-card--featured');
      });
    });
  })();

  /* ─── 6. Announcement bar — cycling messages ─── */
  (function initAnnouncementCycle() {
    const bar = document.querySelector('.announcement-bar__message-wrapper');
    if (!bar) return;
    const msgs = bar.querySelectorAll('.announcement-bar__message');
    if (msgs.length !== 1 || !msgs[0]) return;
    const extras = [
      'New arrivals every week — shop the latest',
      'Free UK delivery over \u00a340',
      '30-day hassle-free returns',
    ];
    const original = msgs[0].textContent.trim();
    const all = [original, ...extras].filter(Boolean);
    let idx = 0;
    setInterval(() => {
      idx = (idx + 1) % all.length;
      msgs[0].classList.add('mise-bar-fade-out');
      setTimeout(() => {
        msgs[0].textContent = all[idx];
        msgs[0].classList.remove('mise-bar-fade-out');
        msgs[0].classList.add('mise-bar-fade-in');
        setTimeout(() => msgs[0].classList.remove('mise-bar-fade-in'), 400);
      }, 300);
    }, 4000);
  })();

  /* ─── 7. Cart drawer — entering animation ─── */
  (function initCartDrawerAnimation() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const obs = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.attributeName === 'open' && drawer.hasAttribute('open')) {
          drawer.classList.add('mise-drawer--entering');
          setTimeout(() => drawer.classList.remove('mise-drawer--entering'), 450);
        }
      });
    });
    obs.observe(drawer, { attributes: true });
  })();

})();
